// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1Neo4jServerHealthType } from './V1Neo4jServerHealthType';
import {
  V1Neo4jServerHealthTypeFromJSON,
  V1Neo4jServerHealthTypeFromJSONTyped,
  V1Neo4jServerHealthTypeToJSON,
  V1Neo4jServerHealthTypeToJSONTyped,
} from './V1Neo4jServerHealthType';
import type { V1DatabaseMode } from './V1DatabaseMode';
import {
  V1DatabaseModeFromJSON,
  V1DatabaseModeFromJSONTyped,
  V1DatabaseModeToJSON,
  V1DatabaseModeToJSONTyped,
} from './V1DatabaseMode';
import type { V1Neo4jServerStateType } from './V1Neo4jServerStateType';
import {
  V1Neo4jServerStateTypeFromJSON,
  V1Neo4jServerStateTypeFromJSONTyped,
  V1Neo4jServerStateTypeToJSON,
  V1Neo4jServerStateTypeToJSONTyped,
} from './V1Neo4jServerStateType';

/**
 *
 * @export
 * @interface V1UnifiedServerStatus
 */
export interface V1UnifiedServerStatus {
  /**
   *
   * @type {string}
   * @memberof V1UnifiedServerStatus
   */
  address?: string;
  /**
   *
   * @type {V1Neo4jServerHealthType}
   * @memberof V1UnifiedServerStatus
   */
  health?: V1Neo4jServerHealthType;
  /**
   *
   * @type {Array<string>}
   * @memberof V1UnifiedServerStatus
   */
  hosting?: Array<string>;
  /**
   *
   * @type {V1DatabaseMode}
   * @memberof V1UnifiedServerStatus
   */
  modeConstraint?: V1DatabaseMode;
  /**
   *
   * @type {string}
   * @memberof V1UnifiedServerStatus
   */
  neo4jFullVersion?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof V1UnifiedServerStatus
   */
  requestedHosting?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof V1UnifiedServerStatus
   */
  serverId?: string;
  /**
   *
   * @type {string}
   * @memberof V1UnifiedServerStatus
   */
  serverName?: string;
  /**
   *
   * @type {string}
   * @memberof V1UnifiedServerStatus
   */
  serverPool?: string;
  /**
   *
   * @type {V1Neo4jServerStateType}
   * @memberof V1UnifiedServerStatus
   */
  state?: V1Neo4jServerStateType;
  /**
   *
   * @type {boolean}
   * @memberof V1UnifiedServerStatus
   */
  statefulSetExists?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1UnifiedServerStatus
   */
  statefulSetName?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1UnifiedServerStatus
   */
  statefulSetNeedsReplacing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1UnifiedServerStatus
   */
  statefulSetReady?: boolean;
}

/**
 * Check if a given object implements the V1UnifiedServerStatus interface.
 */
export function instanceOfV1UnifiedServerStatus(
  value: object,
): value is V1UnifiedServerStatus {
  return true;
}

export function V1UnifiedServerStatusFromJSON(
  json: any,
): V1UnifiedServerStatus {
  return V1UnifiedServerStatusFromJSONTyped(json, false);
}

export function V1UnifiedServerStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1UnifiedServerStatus {
  if (json == null) {
    return json;
  }
  return {
    address: json['address'] == null ? undefined : json['address'],
    health:
      json['health'] == null
        ? undefined
        : V1Neo4jServerHealthTypeFromJSON(json['health']),
    hosting: json['hosting'] == null ? undefined : json['hosting'],
    modeConstraint:
      json['modeConstraint'] == null
        ? undefined
        : V1DatabaseModeFromJSON(json['modeConstraint']),
    neo4jFullVersion:
      json['neo4jFullVersion'] == null ? undefined : json['neo4jFullVersion'],
    requestedHosting:
      json['requestedHosting'] == null ? undefined : json['requestedHosting'],
    serverId: json['serverId'] == null ? undefined : json['serverId'],
    serverName: json['serverName'] == null ? undefined : json['serverName'],
    serverPool: json['serverPool'] == null ? undefined : json['serverPool'],
    state:
      json['state'] == null
        ? undefined
        : V1Neo4jServerStateTypeFromJSON(json['state']),
    statefulSetExists:
      json['statefulSetExists'] == null ? undefined : json['statefulSetExists'],
    statefulSetName:
      json['statefulSetName'] == null ? undefined : json['statefulSetName'],
    statefulSetNeedsReplacing:
      json['statefulSetNeedsReplacing'] == null
        ? undefined
        : json['statefulSetNeedsReplacing'],
    statefulSetReady:
      json['statefulSetReady'] == null ? undefined : json['statefulSetReady'],
  };
}

export function V1UnifiedServerStatusToJSON(json: any): V1UnifiedServerStatus {
  return V1UnifiedServerStatusToJSONTyped(json, false);
}

export function V1UnifiedServerStatusToJSONTyped(
  value?: V1UnifiedServerStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    address: value['address'],
    health: V1Neo4jServerHealthTypeToJSON(value['health']),
    hosting: value['hosting'],
    modeConstraint: V1DatabaseModeToJSON(value['modeConstraint']),
    neo4jFullVersion: value['neo4jFullVersion'],
    requestedHosting: value['requestedHosting'],
    serverId: value['serverId'],
    serverName: value['serverName'],
    serverPool: value['serverPool'],
    state: V1Neo4jServerStateTypeToJSON(value['state']),
    statefulSetExists: value['statefulSetExists'],
    statefulSetName: value['statefulSetName'],
    statefulSetNeedsReplacing: value['statefulSetNeedsReplacing'],
    statefulSetReady: value['statefulSetReady'],
  };
}
